var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.498,
    height: 21.491,
    viewBox: "0 0 21.498 21.491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-zoom-in",
    transform: "translate(-11.677 -144.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M159.333,164.445l-6.22-6.22a8.155,8.155,0,1,0-.788.78l6.229,6.229a.544.544,0,0,0,.385.158.58.58,0,0,0,.394-.158A.555.555,0,0,0,159.333,164.445Zm-7.341-6.649-.088.088a6.938,6.938,0,1,1,2.076-4.95A6.86,6.86,0,0,1,151.992,157.8Z",
    transform: "translate(-126.823)",
    fill: "#010101",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M286.388,292.1l-.088.088a.105.105,0,0,1,.044-.044C286.361,292.126,286.379,292.118,286.388,292.1Z",
    transform: "translate(-261.218 -134.304)",
    fill: "#010101",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M200.548,203.124a.55.55,0,0,1-.552.552h-2.12v2.12a.552.552,0,1,1-1.1,0v-2.12h-2.12a.552.552,0,1,1,0-1.1h2.12v-2.12a.552.552,0,1,1,1.1,0v2.12H200A.555.555,0,0,1,200.548,203.124Z",
    transform: "translate(-177.096 -50.182)",
    fill: "#010101",
    stroke: "#000",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoomIn.94bd31c1f607c8c12d55701b755c6dc8.svg";
export { ForwardRef as ReactComponent };